import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

export const getPaymentConfig = createAsyncThunk(
  'paymentConfig',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/paymentconfig');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getPaymentConfigById = createAsyncThunk(
  'paymentConfig/id',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get(`/paymentconfig/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addPaymentConfig = createAsyncThunk(
  'paymentConfig/add',
  async ({ payload, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/paymentconfig', payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updatePaymentConfig = createAsyncThunk(
  'paymentConfig/update',
  async ({ payload, id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.put(`/paymentconfig/${id}`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deletePaymentConfig = createAsyncThunk(
  'paymentConfig/delete',
  async ({ id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.delete(`/paymentconfig/${id}`, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const invalidateCache = createAsyncThunk(
  'paymentConfig/refreshCache',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/paymentconfig/invalidatecache');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const configSlice = createSlice({
  name: 'config',
  initialState: {
    list: [],
  },
  reducers: {},
  extraReducers: {
    [getPaymentConfig.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        state.list = [];
        return;
      }

      if (!action.payload || !action.payload.data) {
        return;
      }

      state.list = [...action.payload.data];
    },
    [addPaymentConfig.fulfilled]: (state, action) => {
      if (action.payload.status !== 'Created') {
        return;
      }

      const newToggle = action.payload.data;
      state.list.push(newToggle);
    },
    [updatePaymentConfig.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const updatedId = action.payload.data && action.payload.data.id;
      const data = [...state.list];
      const updateIndex = data.findIndex((config) => config.id === updatedId);

      if (updateIndex !== -1) {
        data[updateIndex] = { ...action.payload.data };
        state.list = [...data];
      }
    },
    [deletePaymentConfig.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const data = [...state.list];
      const deletedId = action.payload.id;
      const deletedIndex = data.findIndex((config) => config.id === deletedId);
      data.splice(deletedIndex, 1);
      state.list = [...data];
    },
  },
});

export const configActions = configSlice.actions;

export default configSlice.reducer;
